import { Route, Routes } from "react-router-dom";
import Courses from '../pages/Dashboard/Courses';
import AdminLayout from '../components/Layout/AdminLayout';
import Students from "../pages/Dashboard/Students";
import AssignCourse from "../pages/Dashboard/AssignCourse";
import UserProfile from "../pages/Dashboard/UserProfile";
import Reviews from "../pages/Dashboard/Reviews";
import StudentsRequests from "../pages/Dashboard/StudentsRequests";
import StudentProgress from "../pages/Dashboard/StudentProgress";
import Coupons from "../pages/Dashboard/Coupouns";
import Packages from "../pages/Dashboard/Packages";
import FreezeStudent from "../pages/Dashboard/FreezeStudent";
import SupportCenter from "../pages/Dashboard/SupportCenter";
import Books from "../pages/Dashboard/Books";
import BookRequests from "../pages/Dashboard/BookRequests";
const SalesRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index path="/students" element={<Students />} />
        <Route path="/students/:id" element={<UserProfile />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/student-progress/:id" element={<StudentProgress />} />
        <Route path="/courses/freeze-student/:id" element={<FreezeStudent />} />
        <Route path="/books" element={<Books />} />
        <Route path="/books-requests" element={<BookRequests />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/requests" element={<StudentsRequests />} />
        <Route path="/support" element={<SupportCenter />} />
        <Route path="/assign-course" element={<AssignCourse />} />
        <Route path="/packages" element={<Packages />} />

        <Route path="/coupons" element={<Coupons />} />
      </Route>
    </Routes>
  );
};

export default SalesRoutes;
